import React from "react";
import { Step, StepTitle, Stepper } from "react-progress-stepper";
import { useTranslation } from "react-i18next";
import { downloadFile, formatAmount } from "../../util/common";
import { quotationStatus } from "../../util/constants";
import { getFormattedCarNumberPlate } from "../../util/carOptionsUtils";
import { currentLanguage } from "../../util/common";
import { Icon, Button, RiyalIcon } from "../shared";
import { useAppNavigation } from "../../hooks";

const QuotationProgress = ({ quotations }) => {
  const { t } = useTranslation();
  const { localeRoutes, toUrlWithData } = useAppNavigation();

  const language = currentLanguage();

  const createMasterStep = (masterStatus) => {
    const status = quotationStatus[masterStatus];

    const step1Props = { customContent: undefined };
    if (status === 0) {
      step1Props.customContent = () => <div className="current-step" />;
    }

    const step2Props = { customContent: undefined };
    if (status === 1) {
      step2Props.customContent = () => <div className="current-step" />;
    }

    return (
      <>
        <Stepper step={status} numbered={false}>
          <Step {...step1Props}>
            <StepTitle>{t("track.statusRequested")}</StepTitle>
          </Step>
          <Step {...step2Props}>
            <StepTitle>{t("track.statusInProgress")}</StepTitle>
          </Step>
          <Step customContent={() => <Icon iconName="medal" />}>
            <StepTitle>{t("track.statusCompleted")}</StepTitle>
          </Step>
        </Stepper>
      </>
    );
  };

  const navigateToBook = (q) => {
    toUrlWithData(localeRoutes.appointment[language], {
      quotationId: q?._id
    });
  };

  return (
    <>
      {quotations.map((quote, i) => {
        let parentClass = "row request-estimate-body quote-body estimate-head ";
        parentClass += quote?.isApproved ? " estimation-approved" : "";
        parentClass += quote?.isExpired ? " estimation-expired" : "";
        parentClass += quote?.isAppointmentCreated ? " estimation-booked" : "";

        const car = quote.carData[0];

        return (
          <div className={parentClass} key={i}>
            <div className="col-md-3 col-lg-3 col-xl-2 status-for">
              <h5>
                {quote.otherBrand || car.brand["value_" + language]}{" "}
                {quote.otherModel || car.product["value_" + language]}
                <br />
                {getFormattedCarNumberPlate(quote.licencePlate)}
              </h5>
              {window.innerWidth <= 991 && quote?.isApproved && (
                <div className="estimation-data">
                  <span className="moreDetails">
                    {t("track.cost")}:{" "}
                    <span className="fw-bold">
                      <RiyalIcon /> {formatAmount(quote?.cost)}
                    </span>
                  </span>
                  <a className="pdf-link">
                    <button onClick={() => downloadFile(quote?.costPdf)}>
                      {t("track.downloadQuotation")}
                    </button>
                  </a>

                  {!quote?.isAppointmentCreated && !quote?.isExpired && (
                    <div className="estimation-btn">
                      <Button
                        type="small-roundedRight"
                        customize="m-0"
                        action={() => navigateToBook(quote)}>
                        {t("track.book")}
                      </Button>
                    </div>
                  )}
                </div>
              )}
              {quote?.isExpired && <p className="expired-label">{t("track.estimationExpired")}</p>}
            </div>
            <div className="col-md-8 col-lg-7 col-xl-8">{createMasterStep(quote?.status)}</div>
            <div className="col-md-1 col-lg-2 col-xl-2 p-0">
              {window.innerWidth > 991 && quote?.isApproved && (
                <div className="estimation-data desktop">
                  <span className="moreDetails">
                    {t("track.cost")}:{" "}
                    <span className="fw-bold">
                      <RiyalIcon /> {formatAmount(quote?.cost)}{" "}
                    </span>
                  </span>
                  <a className="pdf-link">
                    <button onClick={() => downloadFile(quote?.costPdf)}>
                      {t("track.downloadQuotation")}
                    </button>
                  </a>

                  {!quote?.isAppointmentCreated && !quote?.isExpired && (
                    <div className="estimation-btn">
                      <Button
                        type="small-roundedRight"
                        customize="m-0"
                        action={() => navigateToBook(quote)}>
                        {t("track.book")}
                      </Button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default React.memo(QuotationProgress);
